import {AxiosError} from 'axios';
import {POST_SET_PASSWORD_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response
// =============================================================================
export interface SetPasswordRequest {
  link: string;
  password: string;
  otpType: string;
  email: string;
  countryCode: number;
  number: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSetPassword = ({onSuccess, onError}: Input = {}) => {
  const postSetPassword = async (reqBody: SetPasswordRequest) => {
    await axiosClient.post(POST_SET_PASSWORD_URL, reqBody);
  };

  return useCustomMutation(
      postSetPassword,
      {
        onSuccess,
        onError,
      },
      false
  );
};
